module.exports = __webpack_public_path__ + "media/images/mobile/jobs/banner-f5cbf9c7372853ca4478728a27ff4113.jpg";